import React from "react";
import { Button, Empty, Skeleton, Table } from "antd";
import { TABLE_PAGINATION } from "../../utilities/helper";

/**
 * Empty state for lists: explains why the list is empty and offers to clear
 * the search when one is applied.
 */
export const TableEmpty = ({
  noun = "records",
  search,
  filtered = false,
  onClearSearch,
}) => {
  const term = (search || "").trim();

  let description = `No ${noun} found`;
  if (term) {
    description = `No ${noun} match “${term}”`;
  } else if (filtered) {
    description = `No ${noun} match the selected filters`;
  }

  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description}>
      {term && onClearSearch ? (
        <Button size="small" onClick={onClearSearch}>
          Clear search
        </Button>
      ) : null}
    </Empty>
  );
};

/**
 * Shared list table:
 * - skeleton rows while the first page loads
 * - horizontal scroll on narrow screens (scrollX = min table width in px),
 *   with `fixed: "right"` action columns staying visible
 * - shared pagination and empty state
 */
const DataTable = ({
  skeleton = false,
  scrollX,
  emptyProps,
  className = "",
  pagination = TABLE_PAGINATION,
  ...tableProps
}) => {
  if (skeleton) {
    return (
      <div className={`table-skeleton ${className}`.trim()}>
        <Skeleton active title={false} paragraph={{ rows: 6 }} />
      </div>
    );
  }

  return (
    <Table
      size="small"
      tableLayout="auto"
      scroll={scrollX ? { x: scrollX } : undefined}
      pagination={pagination}
      locale={{ emptyText: <TableEmpty {...emptyProps} /> }}
      className={`table ${className}`.trim()}
      {...tableProps}
    />
  );
};

export default DataTable;
